var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.data.number)?_c('span',{staticClass:"text",class:'type'+_vm.data.number},[(_vm.showNumber)?_c('span',[_vm._v(_vm._s(_vm.data.number+'、'))]):_vm._e(),_vm._v(" "+_vm._s(_vm.data.content))]):_c('span',[_vm._v("--")])])
}
var staticRenderFns = []

export { render, staticRenderFns }